import React, { useEffect, useRef } from 'react';
import LoggedInLayout from 'layouts/LoggedInLayout';
import useLeftMenu from 'hooks/useLeftMenu';
import { MENUS } from 'configs/page';
import CampaignList from 'components/CampaignListOld';
import useCampaigns from 'hooks/useCampaigns';
import useCampaignsSummary from 'hooks/useCampaignsSummary';
import EmptyStateGraphic from 'assets/img/dashboard-empty.png';
import { Link } from 'react-router-dom';
import { PAGE_NAV } from 'configs/page';

const Campaigns = (props) => {
    const [leftMenu, setLeftMenu] = useLeftMenu();
    const mountedRef = useRef(true);
    const { dateRangeID } = useCampaigns();
    const { data: campaignList } = useCampaignsSummary(dateRangeID);

    useEffect(() => {
        return () => { mountedRef.current = false; };
    }, []);

    useEffect(() => {
        if (leftMenu.value !== "CAMPAIGNS" && mountedRef.current)
            setLeftMenu(MENUS.find(menu => menu.value === "CAMPAIGNS"));
    }, [leftMenu, setLeftMenu]);

    return (
        <LoggedInLayout {...props}>
            {/* <div className='mobile-page-header'>
                    <h1>Campaigns</h1>
            </div> */}
            {
                campaignList
                && campaignList.StatsSummaries
                && campaignList.StatsSummaries.length === 0
                &&
                <div className="empty-state">
                    <p className="empty-ghc"><img src={EmptyStateGraphic} alt="Empty state graphic" /></p>
                    <p className="empty-msg">LET'S GET THE BALL ROLLING</p>
                    <p className="sub">Creating and launching a campaign is pretty easy and we'll guide you through the process.</p>
                    <p className="grey btn link"><Link to={PAGE_NAV.CAMPAIGN_ADD} title="Add campaign">Create promotional link</Link></p>
                </div>
            }
            {
                campaignList
                && campaignList.StatsSummaries
                && campaignList.StatsSummaries.length > 0
                &&
                <CampaignList />
            }
        </LoggedInLayout>
    );
};

export default Campaigns;
